module.exports = __webpack_public_path__ + "static/img/4402_phase_function_Paper_PointsHejduk_Prediction.5011cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4402_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 23kc
// module chunks = 0